import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseOrdergifts } from "./UseOrdergifts";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import CategoryAutoComplete from "../../../basic-information/productCategory/CategoryAutoComplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CategoriesCondition(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { AddCondition, RemoveCondition } = UseOrdergifts();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  const [name, setName] = useState("");
  const [addCategory, setAddCategory] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    giftID: undefined,
    type: undefined,
    value: undefined,
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    giftID: undefined,
    type: undefined,
    value: undefined,
  });

  useEffect(() => {
    setStateAdd({
      giftID: props.giftID,
      type: 1,
      value: undefined,
    });
  }, [props.giftID, props.showCategorys]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "categoryID",
      width: 90,
      align: "center",
      headerName: "کد دسته",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "categoryName",
      width: 300,
      align: "center",
      headerName: "نام دسته بندی",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.categoryName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                giftID: props.giftID,
                type: 1,
                value: cellValues.row.categoryID,
                name: cellValues.row.categoryName,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addCategory",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddCategory(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  const handleChange = (panel) => (event, isExpanded) => {
    if (props.giftID) {
      props.setExpanded(isExpanded ? panel : false);
      if (isExpanded) {
        const element = document.getElementById("panel1");
        setTimeout(() => {
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      enqueueSnackbar("ابتدا اطلاعات فوق را ثبت کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  return (
    <Accordion
      id="panel1"
      expanded={props.expanded === "panel1"}
      onChange={handleChange("panel1")}
      style={{ marginTop: "20px", paddingTop: "5px", paddingBottom: "5px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            لیست دسته بندی ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          <Dialog
            sx={{ zIndex: 200 }}
            fullWidth
            maxWidth="sm"
            open={addCategory}
            onClose={() => setAddCategory(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              sx={{ p: 1, px: 2 }}
              color="secondary"
              id="alert-dialog-title"
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle2">
                  دسته بندی را انتخاب کنید
                </Typography>

                <IconButton
                  onClick={() => {
                    setStateAdd({ ...stateAdd, value: undefined });
                    setAddCategory(false);
                  }}
                >
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CategoryAutoComplete
                  orderGift
                  setName={setName}
                  selectedCategoryID={
                    stateAdd.value ? stateAdd.value : undefined
                  }
                  setter={setStateAdd}
                  lvl1State={stateAdd}
                ></CategoryAutoComplete>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 3,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ mr: 2 }}
                    onClick={() => {
                      if (!stateAdd.value) {
                        enqueueSnackbar("دسته بندی را انتخاب کنید", {
                          variant: "error",
                          autoHideDuration: 2000,
                          preventDuplicate: true,
                        });
                        return;
                      }
                      // return;
                      setProgress(true);
                      AddCondition(stateAdd, () => {
                        props.callback(props.giftID);
                        setAddCategory(false);
                        setStateAdd({ ...stateAdd, value: undefined });
                      });
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        if (!stateAdd.value) {
                          enqueueSnackbar("دسته بندی را انتخاب کنید", {
                            variant: "error",
                            autoHideDuration: 2000,
                            preventDuplicate: true,
                          });
                          return;
                        }
                        AddCondition(stateAdd, () => {
                          setProgress(true);
                          setStateAdd({ ...stateAdd, value: undefined });
                          props.callback(props.giftID);
                          setAddCategory(false);
                        });
                      }
                    }}
                  >
                    ثبت
                  </Button>
                  <Button
                    onClick={() => setAddCategory(false)}
                    color="secondary"
                    variant="outlined"
                  >
                    انصراف
                  </Button>
                </Box>
              </Box>
            </DialogContent>
          </Dialog>
          {props.state.categories ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              rows={props.state.categories ? props.state.categories : []}
              page={pageState.page - 1}
              pageSize={20}
              Pagination
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...pageState, page: newPage + 1 }));
              }}
              rowCount={
                props.state.categories && props.state.categories.length
                  ? props.state.categories.length
                  : 1
              }
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  isLtr: true,

                  noPageCount: true,
                  rowCount:
                    props.state.categories && props.state.categories.length
                      ? props.state.categories.length
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "id",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
          <DeleteRow
            deleteState={deleteState}
            setDeleteState={setDeleteState}
            type={"دسته بندی"}
            callback={() => {
              let sendModel = {
                type: 1,
                giftID: deleteState.giftID,
                value: deleteState.value,
              };
              setProgress(true);
              RemoveCondition(sendModel, () => {
                props.callback(deleteState.giftID);
              });
            }}
          ></DeleteRow>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
